import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';
import { AppLink } from 'components/appLink';

type RoutedThroughCustomAttributesProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_SIDE_CONVERSATION_NODE_VISITED'>;
};

export function RoutedThroughSideConversation({
  node,
}: RoutedThroughCustomAttributesProps): JSX.Element {
  const postfix = node.conversation_id_created ? (
    <>
      Created side conversation{' '}
      <strong>
        <AppLink
          path="/conversation/:csid"
          params={{ path: { csid: node.conversation_id_created.toString() } }}
        >
          #{node.conversation_id_created}
        </AppLink>
      </strong>
    </>
  ) : (
    'No side conversation created'
  );
  return <Text.Paragraph>Side conversation · {postfix}</Text.Paragraph>;
}
